module.exports = __webpack_public_path__ + "img/red-video.610b035e.svg";